import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi, { x } from "@hapi/joi";
import { GreenleafCustomerSummaryReportSchemaObject } from '../GreenleafCustomerSummaryReportSchema';
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _ from 'lodash';
import '../../../Common/Table/table.css';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import { Container, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Button from '@material-ui/core/Button';
import Chip from '@mui/material/Chip';
import xlsx from 'json-as-xlsx';

const screenCode = "WEBBLREPORTGREENLEAFCUSTOMERSUMMARY";
const useStyles = makeStyles({
    tableContainer: {
        maxWidth: '400px',
    },
    arrowContainer: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
    },
    arrowIcon: {
        fontSize: '48px',
        color: '#000',
        pointerEvents: 'auto',
        cursor: 'pointer',
    },
});

export function GreenleafCustomerSummaryReport(props) {
    const classes = useStyles();
    const componentRef = useRef();
    const [groups, setGroups] = useState([]);
    const [totalRow, setTotalRow] = useState(0);
    const [tableData, setTableData] = useState([]);
    const [factories, setFactories] = useState([]);
    const [customerIDs, setCustomerIDs] = useState([]);
    const [tableChunkedArray, setTableChunkedArray] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [greenLeafCustomerSummaryDetails, setGreenLeafCustomerSummaryDetails] = useState({
        groupID: "0",
        operationEntityID: "0",
        date: new Date(),
    });
    const [csvData, setCsvData] = useState([]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: "0",
        operationEntityID: "0",
        date: new Date(),
    });

    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(GreenleafCustomerSummaryReportSchemaObject).options({ allowUnknown: true });
    const csvHeaders = [
        { label: " Reg No", value: "registrationNumber" },
        { label: "Net Quantity (Kg)", value: "totalAmount" }
    ];

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [greenLeafCustomerSummaryDetails.groupID]);

    useEffect(() => {
        trackPromise(
            getAllCustomerIDsForOE(),
        )
    }, [greenLeafCustomerSummaryDetails.operationEntityID])

    function handleGroupChange(target) {
        validateInputs(target);
        setGreenLeafCustomerSummaryDetails({
            ...greenLeafCustomerSummaryDetails,
            groupID: target.value,
            operationEntityID: "0"
        });
    }

    function handleFactoryChange(target) {
        validateInputs(target);
        setGreenLeafCustomerSummaryDetails({
            ...greenLeafCustomerSummaryDetails,
            operationEntityID: target.value,
        });
    }

    function handleSearchDateChange(target) {
        validateInputs(target);
        setGreenLeafCustomerSummaryDetails({
            ...greenLeafCustomerSummaryDetails,
            date: target.value
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, GreenleafCustomerSummaryReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];
        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWWEBBLREPORTGREENLEAFCUSTOMERSUMMARY');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();
        setGreenLeafCustomerSummaryDetails({
            ...greenLeafCustomerSummaryDetails,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(greenLeafCustomerSummaryDetails.groupID);
        setFactories(data);
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }
    async function getAllCustomerIDsForOE() {
        const result = await services.getCustomerIDs(greenLeafCustomerSummaryDetails.operationEntityID);
        setCustomerIDs(result);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch(e) {
        e.preventDefault();
        const errorMessages = validate(schema, greenLeafCustomerSummaryDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        const results = await services.getgreenLeafReportData(greenLeafCustomerSummaryDetails);
        getSelectedDropdownValuesForReport(greenLeafCustomerSummaryDetails);
        var resultsOne = _.cloneDeep(results)
        formatResult(resultsOne);
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            operationEntity: factories[searchForm.operationEntityID],
            date: searchForm.date
        })
    }

    function formatResult(data) {
        const missingCustomerIDs = customerIDs.filter((customer) => {
            return !data.some((item) => item.customerID === parseInt(customer.customerID));
        });

        missingCustomerIDs.forEach(x => {
            data.push({
                registrationNumber: x.registrationNumber,
                customerID: x.customerID,
                totalAmount: 0,
                returnCustomerID: 0,
                netWeight: 0,
                transactionTypeCode: "LF"
            })
        });

        const returnList = data.filter(x => (x.transactionTypeCode == "RET") && (x.totalAmount != 0));
        const notReturnList = data.filter(x => (x.transactionTypeCode != "RET") && (x.totalAmount != 0));
        var returnListOne = _.cloneDeep(returnList)
        var notReturnListOne = _.cloneDeep(notReturnList)

        notReturnListOne.forEach(x => {
            const value = returnListOne.find(y => y.returnCustomerID === x.customerID);
            x.totalAmount = (x.totalAmount - (value == undefined ? 0 : value.totalAmount));
        })

        let TotalAmount = 0;
        notReturnListOne.forEach(y => {
            TotalAmount = TotalAmount + y.totalAmount;
        })

        setTableData(notReturnListOne);
        setTotalRow(TotalAmount);

        const chunkedArray = [];
        const chunkSize = 15;
        for (let i = 0; i < notReturnListOne.length; i += chunkSize) {
            const chunk = notReturnListOne.slice(i, i + chunkSize);
            chunkedArray.push(chunk);
        }
        setTableChunkedArray(chunkedArray);
        setCsvData(notReturnListOne);
    }

    function createFile() {
        var settings = {
            sheetName: 'GLCS Report',
            fileName: 'GLCSummaryReport',
            writeOptions: {}
        }
        var newRow1 = {
            registrationNumber: "Group :" + groups[greenLeafCustomerSummaryDetails.groupID],
            totalAmount: "Factory : " + factories[greenLeafCustomerSummaryDetails.operationEntityID],
            registrationNumber: "Date : " + greenLeafCustomerSummaryDetails.date,
        }
        csvData.push({}, {}, newRow1)
        xlsx(csvHeaders, csvData, settings, true)
    }

    const itemsPerPage = 3;
    const totalPages = Math.ceil(tableChunkedArray.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentTableData = tableChunkedArray.slice(startIndex, endIndex);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    function ClearAll() {
        setGreenLeafCustomerSummaryDetails({
            ...greenLeafCustomerSummaryDetails,
            groupID: "0",
            operationEntityID: "0",
            date: new Date()
        });
    }

    return (
        <Fragment >
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Green Leaf Customer Summary Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md-4">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={greenLeafCustomerSummaryDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={greenLeafCustomerSummaryDetails.operationEntityID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["operationEntityID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="date">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            type="date"
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["date"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["date"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={e => ClearAll(e)}
                                    />
                                </div>
                            </form>
                            {tableData.length != 0 ?
                                <>
                                    <Container style={{ marginTop: '40px' }}>
                                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                                            {currentTableData.map((x, index) => (
                                                <div key={index} style={{ marginRight: '15px' }}>
                                                    <Card style={{ justifyContent: 'center' }}>
                                                        <Paper>
                                                            <TableContainer className={classes.tableContainer}>
                                                                <Table aria-label="simple table" style={{ width: '400px' }}>
                                                                    <TableHead>
                                                                        <TableRow style={{ border: '2px solid black' }}>
                                                                            <TableCell align="center" rowSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', padding: '5px' }}>
                                                                                Reg No
                                                                            </TableCell>
                                                                            <TableCell align="center" colSpan={2} style={{ border: '2px solid black', fontWeight: 'bold', padding: '5px' }}>
                                                                                Net Quantity (Kg)
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {x.map((item, index) => (
                                                                            (item.totalAmount > 0 ?
                                                                                <TableRow style={{ border: '2px solid black' }} key={index}>
                                                                                    <TableCell align="center" style={{ border: '2px solid black', fontWeight: 'bold', backgroundColor: '#c4e6bf' }}>
                                                                                        {item.registrationNumber}
                                                                                    </TableCell>
                                                                                    <TableCell align="center" style={{ border: '2px solid black', fontWeight: 'bold', backgroundColor: '#c4e6bf' }}>
                                                                                        {item.totalAmount == 0 ? parseFloat(item.totalAmount) : parseFloat(item.totalAmount).toFixed(2)}
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                                :
                                                                                <TableRow style={{ border: '2px solid black' }} key={index}>
                                                                                    <TableCell align="center" style={{ border: '2px solid black', fontWeight: 'bold' }}>
                                                                                        {item.registrationNumber}
                                                                                    </TableCell>
                                                                                    <TableCell align="center" style={{ border: '2px solid black', fontWeight: 'bold' }}>
                                                                                        {item.totalAmount == 0 ? parseFloat(item.totalAmount) : parseFloat(item.totalAmount).toFixed(2)}
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            )
                                                                        ))}
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>
                                                        </Paper>
                                                    </Card>
                                                </div>
                                            ))}
                                        </div>
                                    </Container>
                                    <Card>
                                        <Box
                                            display="flex"
                                            justifyContent="flex-start"
                                            alignItems="center"
                                            marginLeft="100px"
                                            fontWeight="bold"
                                            marginTop="15px"
                                            marginBottom="15px"
                                        >
                                            <Chip label={`Total = ${parseFloat(totalRow).toFixed(2)}`} />
                                        </Box>
                                    </Card>
                                    <Grid container spacing={1} justify="center" style={{ marginTop: '50px' }}>
                                        <Grid >
                                            {currentPage > 1 && (
                                                <Button variant="outlined"
                                                    color="secondary"
                                                    style={{ borderColor: '#4dbc5f', color: '#4dbc5f' }}
                                                    startIcon={<ArrowBackIcon />}
                                                    onClick={() => handlePageChange(currentPage - 1)}>
                                                    Back
                                                </Button>
                                            )}
                                        </Grid>
                                        <Grid item style={{ margin: '0 10px' }}>  </Grid>
                                        <Grid >
                                            {currentPage < totalPages && (
                                                <Button variant="outlined"
                                                    color="secondary"
                                                    style={{ borderColor: '#4dbc5f', color: '#4dbc5f' }}
                                                    endIcon={<ArrowForwardIcon />}
                                                    onClick={() => handlePageChange(currentPage + 1)}
                                                >
                                                    Next
                                                </Button>
                                            )}
                                        </Grid>
                                    </Grid>
                                </>
                                : null}
                            {tableData.length > 0 ?
                                <div className="pt-2" style={{ paddingRight: "8%" }}>
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                    <ReactToPrint
                                        documentTitle={"Green Leaf Customer Summary Report"}
                                        trigger={() => <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="PDF"
                                        />}
                                        content={() => componentRef.current}
                                    />
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef}
                                            searchData={selectedSearchValues}
                                            data={tableData}
                                            totalRow={totalRow}
                                        />
                                    </div>
                                </div>
                                : null}
                        </div>
                    </div>
                </div>
            </div >
        </Fragment >
    );
}
